const EnergyMotion = () => {
  return (
    <div
      className="relative hidden overflow-hidden lg:block"
      style={{
        backgroundImage:
          "radial-gradient(760px 520px at 78% 14%, rgba(127,185,46,.16), transparent 58%), radial-gradient(680px 560px at 12% 92%, rgba(47,87,160,.24), transparent 58%), linear-gradient(160deg,#081321 0%,#0c1d33 48%,#123151 100%)",
      }}
    >
      <div
        className="absolute inset-0 opacity-60"
        style={{ backgroundImage: "radial-gradient(rgba(255,255,255,.07) 1px, transparent 1px)", backgroundSize: "28px 28px" }}
      />

      <div className="relative mx-auto flex h-full w-full max-w-[560px] flex-col items-center justify-center gap-8 px-14 py-14">
        <svg className="w-full max-w-[420px]" viewBox="0 0 420 470">
          <defs>
            <linearGradient id="login-flow-grad" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0%" stopColor="#5b8bd6" />
              <stop offset="100%" stopColor="#7fb92e" />
            </linearGradient>
            <linearGradient id="login-panel-grad" x1="0" y1="0" x2="0.4" y2="1">
              <stop offset="0%" stopColor="rgba(91,139,214,.45)" />
              <stop offset="100%" stopColor="rgba(47,87,160,.25)" />
            </linearGradient>
            <radialGradient id="login-sun-grad">
              <stop offset="0%" stopColor="#e8f7c4" />
              <stop offset="55%" stopColor="#a8e05f" />
              <stop offset="100%" stopColor="rgba(127,185,46,0)" />
            </radialGradient>
          </defs>

          <g
            stroke="#a8e05f"
            strokeWidth="1.6"
            strokeLinecap="round"
            opacity=".75"
            style={{ transformOrigin: "340px 62px", animation: "loginSpinSlow 40s linear infinite" }}
          >
            <line x1="340" y1="24" x2="340" y2="34"></line>
            <line x1="340" y1="90" x2="340" y2="100"></line>
            <line x1="302" y1="62" x2="312" y2="62"></line>
            <line x1="368" y1="62" x2="378" y2="62"></line>
            <line x1="313" y1="35" x2="320" y2="42"></line>
            <line x1="360" y1="82" x2="367" y2="89"></line>
            <line x1="367" y1="35" x2="360" y2="42"></line>
            <line x1="320" y1="82" x2="313" y2="89"></line>
          </g>
          <circle
            cx="340"
            cy="62"
            r="30"
            fill="url(#login-sun-grad)"
            opacity=".45"
            style={{ transformOrigin: "340px 62px", animation: "loginBreathe 4.8s ease-in-out infinite" }}
          ></circle>
          <circle cx="340" cy="62" r="15" fill="none" stroke="#a8e05f" strokeWidth="1.8"></circle>

          <g fill="url(#login-panel-grad)" stroke="rgba(168,224,95,.7)" strokeWidth="1.4" strokeLinejoin="round">
            <path d="M32,148 L122,148 L142,104 L52,104 Z"></path>
            <path d="M148,148 L238,148 L258,104 L168,104 Z"></path>
          </g>
          <g stroke="rgba(232,247,196,.4)" strokeWidth="1">
            <line x1="62" y1="148" x2="82" y2="104"></line>
            <line x1="92" y1="148" x2="112" y2="104"></line>
            <line x1="42" y1="126" x2="132" y2="126"></line>
            <line x1="178" y1="148" x2="198" y2="104"></line>
            <line x1="208" y1="148" x2="228" y2="104"></line>
            <line x1="158" y1="126" x2="248" y2="126"></line>
          </g>
          <g stroke="rgba(255,255,255,.35)" strokeWidth="2" strokeLinecap="round">
            <line x1="77" y1="148" x2="77" y2="168"></line>
            <line x1="193" y1="148" x2="193" y2="168"></line>
            <line x1="60" y1="168" x2="94" y2="168"></line>
            <line x1="176" y1="168" x2="210" y2="168"></line>
          </g>

          <g
            fill="none"
            stroke="url(#login-flow-grad)"
            strokeWidth="2"
            strokeLinecap="round"
            strokeDasharray="6 10"
            style={{ animation: "loginFlowLine 1.6s linear infinite" }}
          >
            <path d="M135,172 C135,215 168,212 186,238"></path>
            <path d="M150,350 C182,350 196,332 205,300"></path>
            <path d="M254,268 H300 V150 H332"></path>
            <path d="M254,268 H332"></path>
            <path d="M254,268 H300 V386 H332"></path>
          </g>

          <circle
            cx="210"
            cy="268"
            r="46"
            fill="none"
            stroke="rgba(255,255,255,.14)"
            strokeWidth="1"
            strokeDasharray="3 9"
            style={{ transformOrigin: "210px 268px", animation: "loginSpinBack 22s linear infinite" }}
          ></circle>
          <rect x="180" y="238" width="60" height="60" rx="16" fill="#0f2742" stroke="rgba(168,224,95,.85)" strokeWidth="1.8"></rect>
          <g stroke="#a8e05f" strokeWidth="1.8" strokeLinecap="round" fill="none">
            <line x1="210" y1="252" x2="210" y2="284"></line>
            <line x1="196" y1="262" x2="196" y2="274"></line>
            <line x1="224" y1="262" x2="224" y2="274"></line>
          </g>
          <circle
            cx="210"
            cy="268"
            r="30"
            fill="none"
            stroke="rgba(168,224,95,.35)"
            strokeWidth="1.5"
            style={{ transformOrigin: "210px 268px", animation: "loginBreathe 3.6s ease-in-out infinite" }}
          ></circle>

          <g fill="#0f2742" stroke="rgba(91,139,214,.85)" strokeWidth="1.6">
            <rect x="332" y="126" width="56" height="48" rx="6"></rect>
            <rect x="332" y="244" width="56" height="48" rx="6"></rect>
            <rect x="332" y="362" width="56" height="48" rx="6"></rect>
          </g>
          <g fill="rgba(168,224,95,.7)">
            <rect x="342" y="138" width="9" height="9" rx="2" style={{ animation: "loginFadePulse 3.4s ease-in-out infinite" }}></rect>
            <rect x="358" y="138" width="9" height="9" rx="2"></rect>
            <rect x="342" y="154" width="9" height="9" rx="2"></rect>
            <rect x="342" y="256" width="9" height="9" rx="2"></rect>
            <rect x="358" y="256" width="9" height="9" rx="2" style={{ animation: "loginFadePulse 3.4s ease-in-out .9s infinite" }}></rect>
            <rect x="358" y="272" width="9" height="9" rx="2"></rect>
            <rect x="342" y="374" width="9" height="9" rx="2"></rect>
            <rect x="358" y="390" width="9" height="9" rx="2" style={{ animation: "loginFadePulse 3.4s ease-in-out 1.8s infinite" }}></rect>
            <rect x="342" y="390" width="9" height="9" rx="2"></rect>
          </g>

          <g style={{ animation: "loginDrift 6s ease-in-out infinite" }}>
            <rect x="46" y="300" width="112" height="140" rx="10" fill="#0f2742" stroke="rgba(255,255,255,.28)" strokeWidth="1.6"></rect>
            <g stroke="rgba(255,255,255,.35)" strokeWidth="4" strokeLinecap="round">
              <line x1="64" y1="322" x2="118" y2="322"></line>
              <line x1="64" y1="342" x2="140" y2="342"></line>
              <line x1="64" y1="360" x2="126" y2="360"></line>
            </g>
            <g stroke="rgba(168,224,95,.75)" strokeWidth="4" strokeLinecap="round">
              <line x1="64" y1="380" x2="104" y2="380"></line>
            </g>
            <circle cx="128" cy="410" r="16" fill="rgba(127,185,46,.18)" stroke="#a8e05f" strokeWidth="1.6"></circle>
            <path
              d="M121,410 l5,6 l10,-12"
              fill="none"
              stroke="#a8e05f"
              strokeWidth="2.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></path>
          </g>
        </svg>

        <div className="text-center">
          <h3 className="mb-2.5 text-2xl font-extrabold leading-tight tracking-tight text-white">
            Toda a sua operação de energia em um só lugar
          </h3>
          <p className="text-sm leading-relaxed text-[rgba(205,215,229,.78)]">
            Usinas, unidades consumidoras e faturas sob controle, com dados atualizados a cada ciclo.
          </p>
        </div>
      </div>
    </div>
  );
};

export default EnergyMotion;
